import { scroll } from '../utils/scroll';

export const modal = {
    init() {
        this.modalBook = document.querySelector('.js-modal-book')
        this.closeButtons = document.querySelector('.js-modal-book__close')
        this.openButtons = document.querySelectorAll('.js-modal-book-open')
        this.modalInner = document.querySelector('.c-modal__inner')

        if (!this.modalBook || !this.openButtons.length || !this.closeButtons) return

        this.openButtons.forEach((btn) => {
            btn.addEventListener('click', () => this.openModal(this.modalBook))
        })

        this.closeButtons.addEventListener('click', () => this.closeModal(this.modalBook))

        this.modalBook.addEventListener('click', (e) => {
            // Si el elemento clicado NO es el 'inner' y NO está dentro del 'inner', cerramos
            if (this.modalInner && !this.modalInner.contains(e.target)) {
                this.closeModal(this.modalBook)
            }
        })
    },

    openModal(modal) {
        modal.classList.add('is-active')
        document.body.style.overflow = 'hidden'

        if (scroll.lenis) {
            scroll.lenis.stop();
        }
    },

    closeModal(modal) {
        modal.classList.remove('is-active')
        document.body.style.overflow = 'auto'

        if (scroll.lenis) {
            scroll.lenis.start();
        }
    },
}
